"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _withNullIfStaticBuild = _interopRequireDefault(require("../../withNullIfStaticBuild"));

var _AppBarActionGlobalSearch = _interopRequireDefault(require("./AppBarActionGlobalSearch"));

var _SearchResultSelector = _interopRequireDefault(require("./SearchResultSelector"));

var _useSearch = _interopRequireDefault(require("./useSearch"));

//
// eslint-disable-next-line no-unused-vars
function AppBarActionGlobalSearchComposed(props) {
  var getSearchResult = (0, _useSearch.default)();
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_AppBarActionGlobalSearch.default, (0, _extends2.default)({
    label: t('appBarActionGlobalSearchComposed/label'),
    SearchResultSelector: _SearchResultSelector.default,
    getSearchResult: getSearchResult,
    path: "/search"
  }, props));
}

var _default = (0, _withNullIfStaticBuild.default)(AppBarActionGlobalSearchComposed);

exports.default = _default;